import React from 'react';

import { Container } from 'react-bootstrap';
import Breadcrumbs from './Breadcrumbs';
import SEO from './SEO';
import { bool } from 'prop-types';
import { useState } from 'react';
import { useContext } from 'react';
import { LoadingContext } from './context/LoadingContext';
import { useEffect } from 'react';
import { useCallback } from 'react';
import getNavigationInitialState from '../initialState/navigation';
import usePageNav from '../hooks/usePageNav';
import PageNavCurPageIndicator from './PageNavCurPageIndicator';
import PageNav from './PageNav';
import CollectionList from './CollectionList';
import { useRef } from 'react';
import AppContext from './context/AppContext';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import { ToastContext } from './context/ToastContext';

const MAX_LIMIT_PER_PAGE = 24;

export default function Collections({ isMobile }) {
    const { appContext } = useContext(AppContext);
    const { sendMessage } = useContext(ToastContext);
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const collectionBasePath = collectionPath[0].pathBeforeParams;
    // Loading state
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    /* Pagination code */
    const containerRef = useRef(null);
    const [pagesData, setPagesData] = useState(getNavigationInitialState());
    const {
        curPage,
        curRange,
        nextRange,
        generatedPagesData,
        paginateUser,
    } = usePageNav({ containerRef,
        pagesData });
    /* End pagination code */
    // Fetch collections
    const [collectionList, setCollectionList] = useState([]);
    const fetchCollectionList = useCallback(async () => {
        try {
            startLoading();
            const params = new URLSearchParams({
                page: curPage,
                limit: MAX_LIMIT_PER_PAGE,
            }).toString();
            const response = await fetch(new URL('api/collections?' + params, process.env.APP_URL));
            const data = await response.json();
            setCollectionList(data.collections ?? []);
            if (data.pageInfo) {
                setPagesData({
                    limit: data.pageInfo.limitPerPage,
                    count: data.pageInfo.totalObjects,
                    pages: data.pageInfo.totalPages,
                });
            }
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            finishLoading();
        }
    }, [curPage, MAX_LIMIT_PER_PAGE, startLoading, finishLoading]);
    useEffect(() => {
        fetchCollectionList();
    }, [fetchCollectionList]);
    return (<Container
        style={{ padding: '0' }}
        fluid>
        <div
            className={'page--section'}>
            <SEO
                seoTitle={'Explore Collections - ' + appContext.config.storeName}
                canonicalUrl={new URL(`${collectionBasePath}/`, process.env.APP_URL).toString()}
                breadsArr={[
                    {
                        title: 'Home',
                        handle: '/',
                    },
                    {
                        title: 'Collections',
                        handle: `${collectionBasePath}/`,
                    },
                ]}
            />
            <div
                className={'collection--heading'}>
                <Breadcrumbs
                    breadcrumbList={[
                        [
                            'Collections',
                            `${collectionBasePath}/`,
                        ],
                    ]} />
                <h1
                    className={'collection--title'}>Collections</h1>
                <PageNavCurPageIndicator
                    curRange={curRange}
                    nextRange={nextRange}
                    totalCount={pagesData.count}
                    resourceType={'articles'}
                />
                <CollectionList
                    isMobile={isMobile}
                    isPage={true}
                    collections={collectionList} />
                <PageNav
                    curPage={curPage}
                    totalPages={pagesData.pages}
                    generatedPagesData={generatedPagesData}
                    paginateUser={paginateUser}
                />
            </div>
        </div>
    </Container>);
}

Collections.propTypes = {
    isMobile: bool,
};